import { pointConverter } from "../../../utils/pointConverter";

export const TaskHelper = {
  sizeXs: (size: number) => size <= pointConverter.workingHoursToPixels(1),
  sizeSs: (size: number) => size <= pointConverter.workingHoursToPixels(2),
  sizeSm: (size: number) => size <= pointConverter.workingHoursToPixels(3),
  sizeMd: (size: number) => size <= pointConverter.workingHoursToPixels(4),
  sizeLg: (size: number) => size <= pointConverter.workingHoursToPixels(5),
};
